import React from 'react';
import { Box, Heading } from '@hover/blueprint';
import { SignUpCTAForm } from '../../../common';

const HeroFormDesktop: React.FC = () => (
  <Box
    d={{ base: 'none', desktop: 'flex' }}
    w="610px"
    flexDir="column"
    position="absolute"
    bg="brandNavy.500"
    p={800}
    left="120px"
    top="70px"
    borderRadius="8px"
    shadow="distance300"
    zIndex={101}
  >
    <Heading size={800} color="neutral.0">
      A better way to build.
    </Heading>
    <Heading marginBottom={600} size={500} color="neutral.0" isDisplay>
      HOVER makes home improvement simpler, faster and more collaborative. It
      all starts with a 3D model of your home.
    </Heading>
    <Heading marginBottom={400} size={200} color="neutral.0" isLight>
      Ready to see the possibilities?
    </Heading>
    <SignUpCTAForm inputColor="brandNavy.600" />
  </Box>
);

export default HeroFormDesktop;
